import registerScriptAttacher from "../../lib/script-attacher";

function attachA11YButtonListeners(buttonWrapper: Element) {
	const button = buttonWrapper.querySelector('button');
	if (!button) {
		return;
	}

	const listener = () => {
		const controls = button.getAttribute("aria-controls");
		const dialog = controls
			? document.getElementById(controls) as HTMLDialogElement
			: button.closest(".wp-block-plaudit-base-generic-dialog")?.querySelector("dialog");
		if (dialog) {
			if (button.getAttribute("data-action") === "open") {
				dialog.showModal();
				dialog.ariaExpanded = "true";
			} else {
				dialog.close();
			}
		}
	};

	button.addEventListener('click', listener);
	button.addEventListener('keydown', e => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			listener();
		}
	});
}

registerScriptAttacher("wp-block-plaudit-base-generic-dialog-button", attachA11YButtonListeners);
